module.exports = __webpack_public_path__ + "static/media/coins-message-background.10d47797.png";